import { useRouteContext } from "@tanstack/react-router";

export const useGetCountryVariables = () => {
  const { language, country } = useRouteContext({
    from: "/$locale/_layout",
  });

  return {
    language,
    country,
  };
};
